import { combineReducers } from 'redux';
import changePasswordSlice from 'redux/changePassword/changePasswordSlice';
import forgotPasswordSlice from 'redux/forgotPassword/forgotPasswordSlice';
import topicSwapSlice from 'redux/topicSwap/topicSwapSlice';
import changePhoneSlice from 'redux/changePhone/changePhoneSlice';
import changeEmailSlice from 'redux/changeEmail/changeEmailSlice';
import { investmentOverviewSlice } from 'entities/investmentOverview/model/slice';
import { passwordSlice } from 'entities/password/model/slice';
import { topUpSlice } from 'features/topUp/model/slice';
import { payOutSlice } from 'features/payOut/model/slice';
import { savingPlansSlice } from 'features/savingPlans/model/slice';
import { scheduledOrdersSlice } from 'entities/scheduledOrders/model/slice';
import authSlice from './redux/auth/authSlice';

const rootReducer = combineReducers({
    auth: authSlice.reducer,
    savingPlans: savingPlansSlice.reducer,
    topUp: topUpSlice.reducer,
    payOut: payOutSlice.reducer,
    changePassword: changePasswordSlice.reducer,
    forgotPassword: forgotPasswordSlice.reducer,
    topicSwap: topicSwapSlice.reducer,
    changePhone: changePhoneSlice.reducer,
    changeEmail: changeEmailSlice.reducer,
    investmentOverview: investmentOverviewSlice.reducer,
    password: passwordSlice.reducer,
    scheduledOrders: scheduledOrdersSlice.reducer,
});

export default rootReducer;
